import {
  ANALYTICS_DASHBOARD_API_URL,
  analyticsDashboardQueryKeys,
} from './analytics-dashboard.constants';
import {
  CustomerCreationRateType,
  StatsType,
} from './analytics-dashboard.types';
import { useApiQuery } from '../../hooks';

export function useAnalyticsStats() {
  return useApiQuery<StatsType>(
    `${ANALYTICS_DASHBOARD_API_URL}/stats`,
    analyticsDashboardQueryKeys.stats
  );
}

export function useCustomerCreationRate() {
  return useApiQuery<CustomerCreationRateType>(
    `${ANALYTICS_DASHBOARD_API_URL}/customer_creation_rate`,
    analyticsDashboardQueryKeys.customerCreationRate
  );
}
